export default "__VITE_ASSET__D44X8WFu__"